import { RfTuningStatusResult } from '../status/redux/types'

export type FrequencyRow = {
  LF: string
  LS: string
  TSID: string
  modulation: string
  PWR: {
    value: number
    isHealthy?: boolean
  }
  BERPO: {
    value: string
    isHealthy?: boolean
  }
}

export enum FrequencyHealthStatus {
  healthy = 'healthy',
  unhealthy = 'unhealthy',
}

export type MapDVBCFunction = (dvbc: Array<Array<string>>) => Array<FrequencyRow>

export type MapRFFunction = (frequencies: Array<RfTuningStatusResult>) => Array<FrequencyRow>

export type GetDVBCDataFunction = (data: Array<FrequencyRow>, status?: FrequencyHealthStatus) => Array<FrequencyRow>

export type DVBCContextType = {
  mapDVBC: MapDVBCFunction
  getDVBCData: GetDVBCDataFunction
}

export enum SignalLevelFilter {
  equalOrLessThan = 'equalOrLessThan',
  greaterThan = 'greaterThan',
}

export type SignalLevelFilterType = {
  filter: SignalLevelFilter | ''
  value: number
}

export type FrequenciesFilterState = {
  [FrequenciesFilterField.TSID]?: string
  [FrequenciesFilterField.frequency]?: string
  [FrequenciesFilterField.modulation]?: string
  [FrequenciesFilterField.signalHealth]?: FrequencyHealthStatus | ''
  [FrequenciesFilterField.signalLevel]?: SignalLevelFilterType
}

export enum FrequenciesFilterField {
  TSID = 'TSID',
  frequency = 'frequency',
  modulation = 'modulation',
  signalHealth = 'signalHealth',
  signalLevel = 'signalLevel',
}

export type SetFilterProps = {
  fieldName: FrequenciesFilterField.TSID | FrequenciesFilterField.frequency | FrequenciesFilterField.modulation
  value: string
} | {
  fieldName: FrequenciesFilterField.signalHealth
  value: FrequencyHealthStatus | ''
} | {
  fieldName: FrequenciesFilterField.signalLevel
  filter: SignalLevelFilter | ''
  value: number
}

export type FrequenciesFilterContextType = {
  filter: FrequenciesFilterState,
  setFilter: (props: SetFilterProps) => void
}